import { z } from 'zod'
import { fallback } from '../../../../utilities'

const fallbackData = {
	globalPadding: 36,
	globalFontFamilyOverride: '',
	hide: false,
}

const globalPaddingSchema = z.number().or(fallback(fallbackData.globalPadding))
const globalFontFamilyOverrideSchema = z.string().or(fallback(fallbackData.globalFontFamilyOverride))
const hideSchema = z.boolean().or(fallback(fallbackData.hide))

export const metaGeneralContentSchema = z.object({
	globalPadding: globalPaddingSchema,
	globalFontFamilyOverride: globalFontFamilyOverrideSchema,
	hide: hideSchema,
}).or(fallback(fallbackData))

export type MetaGeneralContentConfiguration = z.infer<typeof metaGeneralContentSchema>

export const metaGeneralContentDefault: MetaGeneralContentConfiguration = metaGeneralContentSchema.parse({})
